import styled from 'styled-components'

export default styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 9px 0;
  padding: 0 30px;
  cursor: pointer;

  .line-info {
    flex: 1;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-left: 8px;

    p {
      margin: 0 !important;
    }
  }
`
